module.exports = __webpack_public_path__ + "img/img_inner_pinkdot.6970e5b4.png";